import t from "@emotion/styled/base";
import { Stack as b } from "../../Stack/index.js";
function d() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const l = /* @__PURE__ */ t(b, process.env.NODE_ENV === "production" ? {
  target: "e2vdryx1"
} : {
  target: "e2vdryx1",
  label: "FullWidthStack"
})(process.env.NODE_ENV === "production" ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : {
  name: "1d3w5wq",
  styles: "width:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvU2VsZWN0Q29tcG9uZW50L1NpbmdsZVNlbGVjdC9TaW5nbGVTZWxlY3Quc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUkyQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9wYXJ0b28tdWkvcGFydG9vLXVpL3BhY2thZ2VzL3VpL3NyYy9jb21wb25lbnRzL1NlbGVjdENvbXBvbmVudC9TaW5nbGVTZWxlY3QvU2luZ2xlU2VsZWN0LnN0eWxlcy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuaW1wb3J0IHsgU3RhY2sgfSBmcm9tICcuLi8uLi9TdGFjayc7XG5cbmV4cG9ydCBjb25zdCBGdWxsV2lkdGhTdGFjayA9IHN0eWxlZChTdGFjaylgXG4gICAgd2lkdGg6IDEwMCU7XG5gO1xuXG5leHBvcnQgY29uc3QgU3R5bGVkU3RhY2sgPSBzdHlsZWQoU3RhY2spYFxuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICB0b3A6IDhweDtcbiAgICByaWdodDogOHB4O1xuYDtcbiJdfQ== */",
  toString: d
}), a = /* @__PURE__ */ t(b, process.env.NODE_ENV === "production" ? {
  target: "e2vdryx0"
} : {
  target: "e2vdryx0",
  label: "StyledStack"
})(process.env.NODE_ENV === "production" ? {
  name: "kmthlo",
  styles: "position:absolute;top:8px;right:8px"
} : {
  name: "kmthlo",
  styles: "position:absolute;top:8px;right:8px/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvU2VsZWN0Q29tcG9uZW50L1NpbmdsZVNlbGVjdC9TaW5nbGVTZWxlY3Quc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVF3QyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9wYXJ0b28tdWkvcGFydG9vLXVpL3BhY2thZ2VzL3VpL3NyYy9jb21wb25lbnRzL1NlbGVjdENvbXBvbmVudC9TaW5nbGVTZWxlY3QvU2luZ2xlU2VsZWN0LnN0eWxlcy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuaW1wb3J0IHsgU3RhY2sgfSBmcm9tICcuLi8uLi9TdGFjayc7XG5cbmV4cG9ydCBjb25zdCBGdWxsV2lkdGhTdGFjayA9IHN0eWxlZChTdGFjaylgXG4gICAgd2lkdGg6IDEwMCU7XG5gO1xuXG5leHBvcnQgY29uc3QgU3R5bGVkU3RhY2sgPSBzdHlsZWQoU3RhY2spYFxuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICB0b3A6IDhweDtcbiAgICByaWdodDogOHB4O1xuYDtcbiJdfQ== */",
  toString: d
});
export {
  l as FullWidthStack,
  a as StyledStack
};
